export function getRoboyuMaxExp(level: number) {
  return level * 100
}
